<template>
  <div class="md-breadcrumd">
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item v-for="(item, index) in dataSource" :key="item.DirID">
        <span @click="breadcrumbClick(item, index)">{{item.DirName}}</span>
      </el-breadcrumb-item>
    </el-breadcrumb>
  </div>
</template>

<script>
export default {
  props: {
    dataSource: { default: [] }
  },
  methods: {
    breadcrumbClick(item, index) {
      if (index >= this.dataSource.length - 1) return;
      this.$emit("breadcrumbClick", item);
    }
  },
}
</script>

<style lang="less">
.md-breadcrumd{
  display: flex;
  // padding-left: 15px;
  .el-breadcrumb{
    height: 32px;
    // background: #e6f3f9;
    // border-radius: 16px;
    display: inline-flex;
    align-items: center;
    padding: 0 12px;
  }
  .el-breadcrumb__inner{
    cursor: pointer;
  }
  .el-breadcrumb__inner,.el-breadcrumb__separator{
    // color: #0989C5;
    font-size: 14px;
  }
  .el-breadcrumb__item:last-child .el-breadcrumb__inner{
    // color: #0989C5;
    font-weight: bold;
  }
}
</style>
